<script setup>
import { Carousel, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'

const props = defineProps({ story: Array, isVisible: Boolean })

const isClient = ref(false)
const currentSlide = ref(0)
const carousel = ref(null)

onMounted(() => {
  if (process.client)
    isClient.value = true
})

useCarouselInert(carousel)
</script>

<template>
  <Carousel
    ref="carousel"
    v-model="currentSlide"
    class="carousel-partner-logo pt-custom-sm"
    snap-align="center"
    :items-to-show="7"
    :breakpoints="{
      0: {
        snapAlign: 'left',
        itemsToShow: 2,
      },
      378: {
        snapAlign: 'center',
        itemsToShow: 3,
      },
      478: {
        snapAlign: 'left',
        itemsToShow: 4,
      },
      768: {
        snapAlign: 'center',
        itemsToShow: 5,
      },
      1024: {
        snapAlign: 'center',
        itemsToShow: 7,
      },
    }"
    :transition="500"
    :autoplay="2500"
    :wrap-around="isClient"
  >
    <Slide v-for="(logo, index) in story" :key="logo" class="flex items-center justify-center">
      <nuxt-img
        :style="{
          transitionDelay: `${100 * (index + 1)}ms`,
        }"
        :class="[isVisible ? 'opacity-100 !translate-y-0' : 'opacity-0! translate-y-[15px]']"
        loading="lazy" class="transition-[transform,opacity] block max-w-[100px] w-full duration-300 ease-in-out" :alt="logo.alt ? logo.alt : 'Trusted Logo'" width="100" height="100" :src="logo.filename"
      />
    </Slide>
  </Carousel>
</template>
